import React, { useState, useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Collapse from "@material-ui/core/Collapse";

import {ReactComponent as PolygonIcon} from '../assets/icons/data_polygon.svg';
import {ReactComponent as RectangleIcon} from '../assets/icons/data_rectangle.svg';

import { SessionContext } from "../context/session-context";

import getExtentFromOLPolygon from '../functions/getExtentFromOLPolygon';

import DrawSquareUp from '../assets/icons/DrawSquare_upSkin.png';
import DrawSquareDown from '../assets/icons/DrawSquare_downSkin.png';
import DrawNodesUp from '../assets/icons/DrawNodes_upSkin.png';
import DrawNodesDown from '../assets/icons/DrawNodes_downSkin.png';
import EditObjectUp from '../assets/icons/EditObject_upSkin.png';
import EditObjectDown from '../assets/icons/EditObject_downSkin.png';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: '2px 2px',
        width: 270,
      },
      textField: {
        marginTop:10,
      },
      container: {
        width: 270
      },
      containerLabel: {
        paddingTop:10,
        paddingBottom:10,
      },
      textItemFont:{
        fontSize: 12
      },
      textCoordField:{
        paddingTop:5,
      },
      rectangeButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${DrawSquareUp})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: 48,
        height: 48,
        '&:hover': {
          backgroundImage: `url(${DrawSquareDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${DrawSquareDown})`,
        },
      },
      polygonButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${DrawNodesUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 48,
        height: 48,
        '&:hover': {
          backgroundImage: `url(${DrawNodesDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${DrawNodesDown})`,
        },
      },
      editButton:{
        backgroundColor: '#FFF', //#0C4C35 
        backgroundImage: `url(${EditObjectUp})`,
        backgroundRepeat: 'no-repeat',  
        backgroundPosition: 'center',     
        width: 48,
        height: 48,
        '&:hover': {
          backgroundImage: `url(${EditObjectDown})`,
        },
        '&.MuiToggleButton-root.Mui-selected': {
          backgroundImage: `url(${EditObjectDown})`,
        },
      },
      drawButton:{
        width:160,
        height: 20,
        color: '#0C4C35',
        border: '1px solid #0C4C35',
        '&:hover': {
          color: '#63D764',
          border: '1px solid #63D764',
        },
      },
      advancedButton: {
        marginTop: 10,
        padding: 5,
        height: 20,
        textAlign: 'left',
        color: '#0C4C35',
        '&:hover': {
          color: '#63D764',
        },
      },
      divider:{
        marginTop:10,
        marginBottom:10,
        marginLeft:0,
        marginRight:0,
      }

}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);


export default function DataToolsPaper(props) {

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);

  const [isPolygonTool, setIsPolygonTool] = useState(false);
  const [isRectangleTool, setIsRectangleTool] = useState(true);
  const [isEditPolygon, setIsEditPolygon] = useState(false);

  const [isAdvanced, setIsAdvanced] = useState(false);

  const [rectangleX, setRectangleX] = useState(0);
  const [rectangleY, setRectangleY] = useState(0);

  const [minX, setMinX] = useState(0);
  const [minY, setMinY] = useState(0);
  const [maxX, setMaxX] = useState(0);
  const [maxY, setMaxY] = useState(0);


   /**
   * Listens for draw completion. 
   */
  useEffect(() => {
    if (sState.caction === 'data' && ((isRectangleTool) || (isPolygonTool))){
      if (isRectangleTool) { setIsRectangleTool(false); }
      if (isPolygonTool) { setIsPolygonTool(false); }
    }
  },[sState.datageom]);

  /**
   * Listens from mapobjects. 
   */
  useEffect(() => {
    if (props.geometry.area > 0){

      const poly = getExtentFromOLPolygon(props.geometry.geometry);
  
      setRectangleX(poly.width.toFixed(2));
      setRectangleY(poly.height.toFixed(2));
      setMinX(poly.minX.toFixed(2));
      setMinY(poly.minY.toFixed(2));
      setMaxX(poly.maxX.toFixed(2));
      setMaxY(poly.maxY.toFixed(2));
  
    } else {
      setRectangleX(0);
      setRectangleY(0);
      setMinX(0);
      setMinY(0);
      setMaxX(0);
      setMaxY(0);
    }
  },[props.geometry]);


  useEffect(() => {
    if (isRectangleTool) { setIsRectangleTool(false); }
    if (isEditPolygon) { setIsEditPolygon(false); }
    
    if (isPolygonTool){
      sDispatch({ type: "setUserAction", payload: { action: "createCustomDataPolygon" } });
      
    }
  },[isPolygonTool]);

  useEffect(() => {
    if (isPolygonTool) { setIsPolygonTool(false); }
    if (isEditPolygon) { setIsEditPolygon(false); }

    if (isRectangleTool){
      sDispatch({ type: "setUserAction", payload: { action: "createCustomDataRectangle" } });
    }
  },[isRectangleTool]);

  useEffect(() => {
    if (isRectangleTool) { setIsRectangleTool(false); }
    if (isPolygonTool) { setIsPolygonTool(false);}

    if (isEditPolygon){
      sDispatch({ type: "setUserAction", payload: { action: "editDataPolygon" } });
    } else {
      sDispatch({ type: "setUserAction", payload: { action: "endEditDataPolygon" } });
    }
  },[isEditPolygon]);


  const resetButtons = () => {
    sDispatch({ type: "setUserAction", payload: { action: "endCustomDataDraw" } });
    if (isRectangleTool) { setIsRectangleTool(false); }
    if (isPolygonTool) { setIsPolygonTool(false); }
    if (isEditPolygon) { setIsEditPolygon(false); }
  }

  const handleRectangleXchange = (event) => {
    const re = /^[0-9.\b]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
        if (event.target.value === '') { event.target.value = 0; }
        const v = parseFloat(event.target.value);
        setRectangleX(v);
    }
  };

  const handleRectangleYchange = (event) => {
    const re = /^[0-9.\b]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      if (event.target.value === '') { event.target.value = 0; }
        const v = parseFloat(event.target.value);
        setRectangleY(v);
    }
  };

  const handleMinXchange = (event) => {
    const re = /^[0-9.\b]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      if (event.target.value === '') { event.target.value = 0; }
        const v = parseFloat(event.target.value);
        setMinX(v);
    }
  };

  const handleMinYchange = (event) => {
    const re = /^[0-9.\b]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      if (event.target.value === '') { event.target.value = 0; }
        const v = parseFloat(event.target.value);
        setMinY(v);
    }
  };

  const handleMaxXchange = (event) => {
    const re = /^[0-9.\b]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      if (event.target.value === '') { event.target.value = 0; }
        const v = parseFloat(event.target.value);
        setMaxX(v);
    }
  };

  const handleMaxYchange = (event) => {
    const re = /^[0-9.\b]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      if (event.target.value === '') { event.target.value = 0; }
        const v = parseFloat(event.target.value);
        setMaxY(v);
    }
  };


  
  const handleDrawXYPolygon = (event) => {
    resetButtons();
    const params = {
      x: rectangleX,
      y: rectangleY,
    }
    sDispatch({ type: "requestdatageom", payload: { action: "createXYPolygon", requestdatageom: params} });

  };

  const handleDrawDefinedPolygon = (event) => {
    resetButtons();
    const params = {
      minX: minX,
      minY: minY,
      maxX: maxX,
      maxY: maxY,
    }
    sDispatch({ type: "requestdatageom", payload: { action: "createCoordPolygon", requestdatageom: params} });
  };
  
 
  return (
    <div className={classes.paper}>
        <div className={classes.container}>
          <Grid container>
            <Grid item xs={6}>
              <Box className={classes.containerLabel} fontWeight="fontWeightBold" fontSize={14}>Custom draw</Box>
              <HtmlTooltip title={<React.Fragment>{"Draw Rectangle"}</React.Fragment>}>
                <ToggleButton className={classes.rectangeButton} value="draw" selected={isRectangleTool} onChange={() => {setIsRectangleTool(!isRectangleTool) } } ><div></div></ToggleButton> 
              </HtmlTooltip> 
              <HtmlTooltip title={<React.Fragment>{"Draw Polygon"}</React.Fragment>}>
                <ToggleButton className={classes.polygonButton} value="draw" selected={isPolygonTool} onChange={() => {setIsPolygonTool(!isPolygonTool) } } ><div></div></ToggleButton>
              </HtmlTooltip>
            </Grid>
            <Grid item xs={6}>
              <Box className={classes.containerLabel} fontWeight="fontWeightBold" fontSize={14}>Edit</Box>
              <HtmlTooltip title={<React.Fragment>{"Edit Polygon"}</React.Fragment>}>
                <ToggleButton className={classes.editButton} value="edit" selected={isEditPolygon} onChange={() => {setIsEditPolygon(!isEditPolygon) } } ><div></div></ToggleButton>
              </HtmlTooltip>
            </Grid>
          </Grid>
        </div>

      <Collapse in={!isAdvanced}>
        <Button className={classes.advancedButton} variant="outlined" onClick={() => setIsAdvanced(true)}>
          <Box p={1} fontWeight="fontWeightBold" fontSize={12}>Advanced area definition</Box>
        </Button>
      </Collapse>
      <Collapse in={isAdvanced}>
        <div className={classes.container}>
          <Box className={classes.containerLabel} fontWeight="fontWeightBold" fontSize={14}>Enter Rectangle Size (m)</Box>
          <Grid container>
            <Grid item xs={6}><TextField className={classes.textField} value={rectangleX} InputProps={{classes: {input: classes.textItemFont}}} id="rectangleX" label="Width" variant="outlined" size="small" onChange={handleRectangleXchange}/></Grid>
            <Grid item xs={6}><TextField className={classes.textField} value={rectangleY} InputProps={{classes: {input: classes.textItemFont}}} id="rectangleY" label="Height" variant="outlined" size="small" onChange={handleRectangleYchange}/></Grid>
          </Grid>
          <Button className={classes.drawButton} variant="outlined" onClick={handleDrawXYPolygon}>
            <Box p={1} fontWeight="fontWeightBold" fontSize={12}>Draw</Box>
          </Button>
          <Divider className={classes.divider} />
          <Box className={classes.containerLabel} fontWeight="fontWeightBold" fontSize={14}>Enter your corner coordinates</Box>
          <Grid container>
            <Grid item xs={6}>
              <Box fontSize={14}>Bottom-left</Box>
              <TextField className={classes.textField} value={minX} InputProps={{classes: {input: classes.textItemFont}}} id="rectangleX" label="X" variant="outlined" size="small" onChange={handleMinXchange}/>
              <TextField className={classes.textField} value={minY} InputProps={{classes: {input: classes.textItemFont}}} id="rectangleY" label="Y" variant="outlined" size="small" onChange={handleMinYchange}/>
            </Grid>
            <Grid item xs={6}>
              <Box fontSize={14}>Top-right</Box>
              <TextField className={classes.textField} value={maxX} InputProps={{classes: {input: classes.textItemFont}}} id="rectangleX" label="X" variant="outlined" size="small" onChange={handleMaxXchange}/>
              <TextField className={classes.textField} value={maxY} InputProps={{classes: {input: classes.textItemFont}}} id="rectangleY" label="Y" variant="outlined" size="small" onChange={handleMaxYchange}/>
            </Grid>
          </Grid>
          <Button className={classes.drawButton} variant="outlined" onClick={handleDrawDefinedPolygon}>
            <Box p={1} fontWeight="fontWeightBold" fontSize={12}>Draw</Box>
          </Button>
        </div>
      </Collapse>

    </div>
  );
}